export const dashboardStoreActions = {
  GET_GLOBAL_DATA_LOADING: 'GET_GLOBAL_DATA_LOADING',
  GET_GLOBAL_DATA_ERROR: 'GET_GLOBAL_DATA_ERROR',
  GET_GLOBAL_DATA: 'GET_GLOBAL_DATA',
};

